import React, { useState } from "react";
import Header1 from "../../Components/seperate Components/Header1";
import Shape2 from "../../assets/brand/choose-shape-2.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import Footer from "../../Components/Footer";
import ModalVideo from "react-modal-video";
import "react-modal-video/scss/modal-video.scss";
import { faPlay } from "@fortawesome/free-solid-svg-icons";
import "../../Styles/Redirecting Styles/FooterStyle/DigitalMarketing.css";
import { Helmet } from "react-helmet";
// import sales from "../../assets/All Images/sales.jpg";
// import sales1 from "../../assets/All Images/sales1.jpg";
// import sales2 from "../../assets/All Images/sales2.jpg";
import seo from "../../assets/icons/seo.png";
import socialMedia from "../../assets/icons/social-media-marketing.png";
import contentMarketing from "../../assets/icons/content-marketing.png";
import payClick from "../../assets/icons/pay-per-click.png";
import marketing from "../../assets/icons/marketing.png";
import { BrandArea2 } from "../../Components/BrandArea2";

const DigitalMarketing = () => {
  const [isOpen, setOpen] = useState(false);

  return (
    <div>
      <Helmet>
        <title>
          Leading Digital Marketing Agency – Premier Services & Solutions
        </title>
        <meta
          name="description"
          content="Achieve success with top digital marketing services. Our trusted company provides expert solutions tailored for your business."
        />
        <meta
          name="keywords"
          content="Leading Digital Marketing Services, Best Digital Marketing Company, Expert Digital Marketing Solutions"
        />
      </Helmet>

      <Header1 />

      {/* Banner section */}
      <div
        className="bd-page-title-area bd-page-title-bg2 pt-220 pb-155"
        style={{ height: "380px" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div
                className="bd-page-title text-center z-index"
                style={{ bottom: "45px" }}
              >
                <h2 className="breadcrumb-title" style={{ fontSize: "50px" }}>
                 IT Engineering Services
                </h2>
                <div className="breadcrumb-menu">
                  <nav className="breadcrumb-trail breadcrumbs">
                    {/* <p style={{ color: "black" }}>
                      Reach a larger audience and boost your sales with digital
                      marketing!
                    </p> */}
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* First section */}
      <section className="bd-choose-area fix pb-70 pt-80 ">
        <div className="container" style={{ maxWidth: "1270px" }}>
          <div className="bd-choose-shape">
            <div className="row">
              <div className="col-xl-6 col-lg-6 order-2 order-lg-1 pr-20">
                <div className="bd-choose-text z-index">
                  <h2
                    className="bd-section-title mb-15"
                    style={{ fontSize: "46px" }}
                  >
                    IT Engineering Services
                  </h2>
                  <div className="bd-section-title-wrapper"></div>
                  <p
                    className="mb-20"
                    style={{ width: "95%", fontSize: "18px" }}
                  >
       Helping enterprises build, operate and maintain Data, Logic, Network and 
       Integration assets in Data Stores, Apps and APIs in Cloud/Hybrid environments.

                  </p>
                  <p className="" style={{ fontSize: "18px" }}>
                Ambrella offers end to end services in Application Engineering space to maximise your investment in technology
                Custom (Bespoke) Application Development<br/>
Package Implementations/Systems Integration<br/>
Operations support in subscription (as-a-service) models<br/>
Testing/Quality Assurance<br/>
Application & Data Integration<br/>
IT Infrastructure & Cloud Management<br/>
App Support/Maintenance<br/>
Enterprise Solution Services<br/>
Resource Hiring & Staff Augmentation<br/>
                  </p>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 order-1 order-lg-2">
                <div className="bd-choose-img text-end  z-index">
                  <div className="row align-items-center media-respon-digital custom-mar-15">
                    <div className="col-xl-6 col-lg-6 col-6 custom-pad-15">
                      <div className="bd-choose-img-inner mb-15 bd-choose-img-inner-1">
                        <img
                          // src={sales}
                          className="resp-img bordertop-img1"
                          alt="img not found"
                        />
                      </div>
                    </div>
                    <div className="col-xl-6 col-lg-6 col-6 custom-pad-15">
                      <div className="bd-choose-img-inner mb-15">
                        <img
                          // src={sales1}
                          className="resp-img bordertop-img2"
                          alt="img not found"
                        />
                      </div>
                      <div className="bd-choose-img-inner mb-15">
                        <img
                          // src={sales2}
                          className="resp-img bordertop-img3"
                          alt="img not found"
                        />
                      </div>
                    </div>
                  </div>
                  <img
                    className="bd-choose-shape bd-choose-shape-2"
                    src={Shape2}
                    alt="shape img not found"
                  />
                  {/* <div className="bd-choose-video-popup">
                                    <a className="play_btn popup-video popup-youtube" onClick={()=> setOpen(true)}>
                                      <i className="fas fa-play"></i></a>
                                      <ModalVideo autoplay isOpen={isOpen} channel='youtube' videoId='L61p2uyiMSo' onClose={() => setOpen(false)}/>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="bd-choose-video-popup first_pop_video"> */}
        {/* <ModalVideo
          autoplay
          isOpen={isOpen}
          channel="youtube"
          videoId="L61p2uyiMSo"
          onClose={() => setOpen(false)}
        ></ModalVideo>
        <button
          style={{ display: "none" }}
          className="btn btn  first_pop_video responsive_digital"
          onClick={() => setOpen(true)}
        >
          <FontAwesomeIcon
            icon={faPlay}
            className="play_bt_vid play_transition"
          />
        </button> */}

        {/* </div> */}
      </section>

      <section className="bd-service-area pb-80 ">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-6 pt-20">
              <div className="bd-section-title-wrapper mb-50">
                <h2 className="bd-section-title" style={{ fontSize: "46px" }}>
                  <span style={{ color: "#098FB4" }}> Digital Marketing </span>{" "}
                  Tailored Services for Your Business Success
                </h2>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div
                className="bd-service mb-30"
                style={{ backgroundColor: "var(--clr-bg-gray)" }}
              >
                <div className="bd-service-icon mb-20">
                  <i>
                    <img src={seo} />
                  </i>
                </div>
                <h4 className="bd-service-title mb-20">
                  <a>Search Engine Optimization (SEO)</a>
                </h4>
                <p>
                  SEO efforts will boost brand visibility and drive more organic
                  traffic.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div
                className="bd-service mb-30"
                style={{ backgroundColor: "var(--clr-bg-gray)" }}
              >
                <div className="bd-service-icon mb-20">
                  <i>
                    <img src={payClick} />
                  </i>
                </div>
                <h4 className="bd-service-title mb-20">
                  <a>Pay-per-Click (PPC)</a>
                </h4>
                <p>
                  The more clicks a link gets, the faster it climbs the ranks,
                  making it a time-efficient strategy.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div
                className="bd-service mb-30"
                style={{ backgroundColor: "var(--clr-bg-gray)" }}
              >
                <div className="bd-service-icon mb-20">
                  <i>
                    <img src={socialMedia} />
                  </i>
                </div>
                <h4 className="bd-service-title mb-20">
                  <a>Social Media Marketing</a>
                </h4>
                <p>
                  Reach the right audience by targeting specific client groups
                  with Facebook and Instagram ads.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div
                className="bd-service mb-30"
                style={{ backgroundColor: "var(--clr-bg-gray)" }}
              >
                <div className="bd-service-icon mb-20">
                  <i>
                    <img src={contentMarketing} />
                  </i>
                </div>
                <h4 className="bd-service-title mb-20">
                  <a>Content Marketing</a>
                </h4>
                <p>
                  Engage with your audience and address their queries. Plus, it
                  helps with lead generation and closing sales.{" "}
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div
                className="bd-service mb-30"
                style={{ backgroundColor: "var(--clr-bg-gray)" }}
              >
                <div className="bd-service-icon mb-20">
                  <i>
                    <img src={marketing} />
                  </i>
                </div>
                <h4 className="bd-service-title mb-20">
                  <a>Marketing Analytics</a>
                </h4>
                <p>
                  Businesses can easily grasp what drives consumer behavior and
                  optimize their ROI.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      {/* <section
        className="bd-video-area pt-135 pb-130"
        style={{ backgroundColor: "#01536E" }}
      >
        <div className="container" style={{ maxWidth: "1270px" }}>
          <div className="row responsive-banner">
            <div className="col-lg-12 first_section">
              <div className="bd-video-text">
                <h2 className="bd-video-title first-para-resp">
                  Need a Digital Marketing Specialist?
                </h2>
                <p className="contact_section second-para-resp">
                  You’re in the right place, at the perfect time.
                </p>
                <p className="contact_subtext">
                  Exceptional digital marketing let’s get started now!
                </p>
              </div>
            </div>
            <div className="col-lg-12 second_section">
              <div className="contact-stuff pt-30">
                <div className="contact_icon icon_respon pt-15 pl-50">
                  <FontAwesomeIcon
                    icon={faPhone}
                    style={{ fontSize: "30px" }}
                  />
                </div>
                <div className="contact_txt ">
                  <p className="contact-sub-text">CALL US NOW</p>
                  <a
                    href="tel:+6587852030"
                    style={{ fontSize: "17px" }}
                    className="mbb-5 pb-20"
                  >
                    +65 87852030
                  </a>
                </div>
              </div>
              <Link to={"/zithas/contact-us"} onClick={toggleContact}>
                    <button className="touch-btn1 mt-20">Get Started</button>
                    </Link>
            </div>
          </div>
        </div>
      </section> */}

      <BrandArea2/>
      <Footer />
    </div>
  );
};

export default DigitalMarketing;
